
import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';
import CardRh from "@/components/cards/ManzaCard.vue";
import InstrutorService from "@/service/v1/sigap/InstrutorService";
import DisciplinaService from "@/service/v1/sigap/DisciplinaService";
import { Options } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Cadastro from "./_Cadastro.vue";
import Multiselect from '@vueform/multiselect';

@Options({
    name: "DisciplinaInstrutorIndex",
    components: { CardRh, KDataTable, Cadastro, Multiselect },
})
export default class DisciplinaInstrutorIndex extends IndexModelTable {
    public disciplinaId: any = null;
    public statusId: any = 1;
    public status: any = null;
    public search = '';
    public pelotao = '';

    public disciplinaService = new DisciplinaService();

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = '';
        this.pelotao = '';
        this.statusId = null;
        this.refreshTable();
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    created() {
        this.service = new InstrutorService();
        this.disciplinaId = this.$route.params.id;
        this.getStatus();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    pelotao: this.pelotao,
                    disciplinaId: this.disciplinaId,
                    status: this.statusId,
                    search: this.search,
                };
                return dados;
            }
        };
        this.config.order = [[1, 'asc']];
        this.config.columns = [
            { data: 'usuario.nome', name: 'usuario', searchable: false },
            { data: 'pelotao', name: 'pelotao' },
            { data: 'escolaridade.nome', name: 'escolaridade', searchable: false },
            { data: 'status.nome', name: 'status', searchable: false },
            { data: 'tipo', name: 'tipo', orderable: false, searchable: false, class: 'text-center' },
        ];

        this.config.columnDefs = [
            {
                targets: 4,
                render: (tipo, type, val) => this.tipoHtml(tipo, val.id),
            },
        ];

        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push({
                targets: 5,
                render: (row, type, val) => {
                    let texto = '';
                    let buttom = '';
                    for (const key in val) {
                        buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                    }
                    texto = texto + '<button class="btn btn-pmes-warning btn-sm" btn-editar-instrutor ' + buttom + '><i class="fa fa-edit"></i></button>';
                    if (val.status.id == 1) {
                        texto = texto + '<button class="btn btn-light-pmes-danger btn-sm border border-pmes-danger" btn-desvincular-instrutor ' + buttom + ' title="Desvincular"><i class="fa fa-link-slash"></i></button>';
                    }
                    if (val.status.id == 2) {
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-vincular-instrutor ' + buttom + ' title="Vincular"><i class="fa fa-link"></i></button>';
                    }
                    return texto;
                },
            });
        }
    }

    // HTML da célula "Tipo": botão clicável (com permissão) que alterna PRINCIPAL/AUXILIAR;
    // ou apenas um badge informativo quando o usuário não pode editar.
    public tipoHtml(tipo: any, id: any): string {
        const tid = tipo && typeof tipo === 'object' ? Number(tipo.id) : Number(tipo);
        const label = tid === 2 ? 'AUXILIAR' : 'PRINCIPAL';
        if (this.hasPermissao) {
            const cls = tid === 2 ? 'btn-light-pmes-warning border border-pmes-warning' : 'btn-pmes-primary';
            return `<button class="btn ${cls} btn-sm" btn-tipo-instrutor data-id="${id}" title="Clique para alternar o tipo">${label}</button>`;
        }
        const badge = tid === 2 ? 'badge-light' : 'badge-light-primary';
        return `<span class="badge ${badge}">${label}</span>`;
    }

    public tableatualizada() {
        $('[btn-excluir-instrutor]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.excluirModelo(id);
        });
        $('[btn-desvincular-instrutor]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.desvincular(id);
        });
        $('[btn-vincular-instrutor]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.vincular(id);
        });
        $('[btn-tipo-instrutor]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.alternarTipo(id);
        });
        $('[btn-editar-instrutor]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            const routeData = this.$router.resolve({ name: 'sigap_Instrutor_editar', params: { id: id } });
            window.open(routeData.href, '_blank');
        });
    }

    protected excluirModelo(id) {
        SiteUtils.alertConfimacao('Confirma a Exclusao', '',
            () => {
                this.processando = true;
                setTimeout(() => {
                    this.service.excluir(id)
                        .then(() => {
                            this.reloadDatatable = !this.reloadDatatable;
                            SiteUtils.toastSucesso('Exclusao realizada com sucesso!!');
                            this.processando = false;
                        })
                        .catch(error => {
                            this.processando = false;
                            SiteUtils.toastErro('Nao foi possivel Excluir', error.data.message);
                        });
                }, 10);
            }
        );
    }

    protected desvincular(id) {
        SiteUtils.alertConfimacao('Confirma a Desvinculacao', '',
            () => {
                this.processando = true;
                setTimeout(() => {
                    this.service.desvincular(id)
                        .then(() => {
                            this.reloadDatatable = !this.reloadDatatable;
                            SiteUtils.toastSucesso('Desvinculacao realizada com sucesso!!');
                            this.processando = false;
                        })
                        .catch(error => {
                            this.processando = false;
                            SiteUtils.toastErro('Nao foi possivel Desvincular', error.data.message);
                        });
                }, 10);
            }
        );
    }

    protected vincular(id) {
        SiteUtils.alertConfimacao('Confirma a vinculacao', '',
            () => {
                this.processando = true;
                setTimeout(() => {
                    this.service.vincular(id)
                        .then(() => {
                            this.reloadDatatable = !this.reloadDatatable;
                            SiteUtils.toastSucesso('Vinculacao realizada com sucesso!!');
                            this.processando = false;
                        })
                        .catch(error => {
                            this.processando = false;
                            SiteUtils.toastErro('Nao foi possivel Vincular', error.data.message);
                        });
                }, 10);
            }
        );
    }

    // Alterna o tipo (PRINCIPAL <-> AUXILIAR). Toggle rapido, sem dialogo de confirmacao.
    protected alternarTipo(id) {
        this.processando = true;
        setTimeout(() => {
            this.service.alternarTipo(id)
                .then(() => {
                    this.reloadDatatable = !this.reloadDatatable;
                    SiteUtils.toastSucesso('Tipo alterado com sucesso!!');
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    SiteUtils.toastErro('Nao foi possivel alterar o tipo', error?.data?.message);
                });
        }, 10);
    }
}
